export default __webpack_public_path__ + "static/media/smileTwo.ff5e5a15.svg";